const hebrewLetters = [
  { name: 'Aleph', abbr: 'A', hebrew: 'א', latin: ['A', 'E'], value: 1 },
  { name: 'Beth', abbr: 'B', hebrew: 'ב', latin: ['B', 'F'], value: 2 },
  { name: 'Gimel', abbr: 'G', hebrew: 'ג', latin: ['G'], value: 3 },
  { name: 'Daleth', abbr: 'D', hebrew: 'ד', latin: ['D'], value: 4 },
  { name: 'He', abbr: 'H', hebrew: 'ה', latin: ['H'], value: 5 },
  { name: 'Vau', abbr: 'V', hebrew: 'ו', latin: ['V', 'U', 'W'], value: 6 },
  { name: 'Zain', abbr: 'Z', hebrew: 'ז', latin: ['Z'], value: 7 },
  { name: 'Cheth', abbr: 'Ch', hebrew: 'ח', latin: ['Ch'], value: 8 },
  { name: 'Teth', abbr: 'T', hebrew: 'ט', latin: ['T'], value: 9 },
  { name: 'Yod', abbr: 'Y', hebrew: 'י', latin: ['Y', 'I', 'J'], value: 10 },
  { name: 'Kaph final', abbr: 'k', hebrew: 'ך', latin: ['k'], value: 500 },
  { name: 'Kaph', abbr: 'K', hebrew: 'כ', latin: ['K', 'C'], value: 20 },
  { name: 'Lamed', abbr: 'L', hebrew: 'ל', latin: ['L'], value: 30 },
  { name: 'Mem final', abbr: 'm', hebrew: 'ם', latin: ['m'], value: 600 },
  { name: 'Mem', abbr: 'M', hebrew: 'מ', latin: ['M'], value: 40 },
  { name: 'Nun final', abbr: 'n', hebrew: 'ן', latin: ['n'], value: 700 },
  { name: 'Nun', abbr: 'N', hebrew: 'נ', latin: ['N'], value: 50 },
  { name: 'Samekh', abbr: 'S', hebrew: 'ס', latin: ['S'], value: 60 },
  { name: 'Ayin', abbr: 'O', hebrew: 'ע', latin: ['O'], value: 70 },
  { name: 'Peh final', abbr: 'p', hebrew: 'ף', latin: ['p'], value: 800 },
  { name: 'Peh', abbr: 'P', hebrew: 'פ', latin: ['P'], value: 80 },
  { name: 'Tzaddi final', abbr: 'tz', hebrew: 'ץ', latin: ['tz'], value: 900 },
  { name: 'Tzaddi', abbr: 'Tz', hebrew: 'צ', latin: ['Tz'], value: 90 },
  { name: 'Qoph', abbr: 'Q', hebrew: 'ק', latin: ['Q'], value: 100 },
  { name: 'Resh', abbr: 'R', hebrew: 'ר', latin: ['R'], value: 200 },
  { name: 'Shin', abbr: 'Sh', hebrew: 'ש', latin: ['Sh'], value: 300 },
  { name: 'Tau', abbr: 'Th', hebrew: 'ת', latin: ['Th'], value: 400 }
]

const hebrewLettersConversionOrder = [
  { from: 'Ch', to: 'Ch' },
  { from: 'tz', to: 'tz' },
  { from: 'Tz', to: 'Tz' },
  { from: 'Sh', to: 'Sh' },
  { from: 'Th', to: 'Th' },
  { from: 'A', to: 'A' },
  { from: 'E', to: 'A' },
  { from: 'B', to: 'B' },
  { from: 'G', to: 'G' },
  { from: 'D', to: 'D' },
  { from: 'H', to: 'H' },
  { from: 'V', to: 'V' },
  { from: 'U', to: 'V' },
  { from: 'W', to: 'V' },
  { from: 'Z', to: 'Z' },
  { from: 'T', to: 'T' },
  { from: 'Y', to: 'Y' },
  { from: 'I', to: 'Y' },
  { from: 'J', to: 'Y' },
  { from: 'k', to: 'k' },
  { from: 'K', to: 'K' },
  { from: 'C', to: 'K' },
  { from: 'L', to: 'L' },
  { from: 'm', to: 'm' },
  { from: 'M', to: 'M' },
  { from: 'n', to: 'n' },
  { from: 'N', to: 'N' },
  { from: 'S', to: 'S' },
  { from: 'O', to: 'O' },
  { from: 'p', to: 'p' },
  { from: 'P', to: 'P' },
  { from: 'F', to: 'P' },
  { from: 'Q', to: 'Q' },
  { from: 'R', to: 'R' },
  { from: 'X', to: 'Tz' }
]

let hebrewLettersMap = {}

for (let order of hebrewLettersConversionOrder) {
  for (let letter of hebrewLetters) {
    if (letter.abbr === order.to) {
      hebrewLettersMap[order.from] = letter
    }
  }
}

const transliterationToHebrew = function (transliteration) {
  let hebrew = transliteration

  for (let order of hebrewLettersConversionOrder) {
    hebrew = hebrew.replace(
      new RegExp(order.from, 'g'),
      hebrewLettersMap[order.to].hebrew
    )
  }

  return hebrew
}

const gematria = function (hebrew) {
  let word = hebrew
  let total = 0

  for (let letter of hebrewLetters) {
    while (word.indexOf(letter.hebrew) > -1) {
      total += letter.value
      word = word.replace(letter.hebrew, '')
    }
  }

  return total
}

const gematriaEquation = function (hebrew) {
  const words = hebrew.split(' ')
  const wordsGematria = []
  let total = 0
  let gematriaEquationValue = ''

  for (let word of words) {
    let wordGematria = gematria(word)
    total += wordGematria
    wordsGematria.push(wordGematria)
  }

  gematriaEquationValue = wordsGematria.join('+')

  if (total === 0) {
    gematriaEquationValue = ''
  }

  if (wordsGematria.length > 1) {
    gematriaEquationValue = gematriaEquationValue + '=' + total
  }

  return gematriaEquationValue
}

export { hebrewLetters, gematria, gematriaEquation, transliterationToHebrew }



// WEBPACK FOOTER //
// ./src/hebrew.js